import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["address", "city", "countrycode", "details", "postalcode", "query"]

  static values = { key: String }

  initialize() {
    this.loadGoogleMaps()
    this.createResultHolders(this.element)
    this.autofillAddress()
  }

  // Downloads the Google Maps Places library and starts the autocompleter
  // once the library is ready.
  loadGoogleMaps() {
    // Google Maps is already loaded, no need to reload it
    if (typeof google == "object" && typeof google.maps == "object") {
      this.startAutocompleter()
      return
    }

    var script = document.createElement("script")
    var parent = document.getElementsByTagName("script")[0].parentNode

    script.src = `https://maps.googleapis.com/maps/api/js?key=${this.keyValue}&libraries=places`
    script.async = 1
    script.defer = 1
    script.onload = this.startAutocompleter // most browsers
    script.onreadystatechange = function () {
      // IE case
      if (this.readyState == "complete") {
        this.startAutocompleter()
      }
    }

    parent.appendChild(script)
  }

  // Initializes the autocompleter and fills the result holders with the
  // values for the selected address.
  // This method is outside of the Stimulus "scope" (due to it being called
  // at the Google Maps script onload event). Therefore, targets cannot be
  // used there. For this reason, jQuery selectors are used.
  // Open to a better solution!
  startAutocompleter() {
    $("#address-field").removeAttr("disabled")

    var autocomplete = new google.maps.places.Autocomplete($("#address-field")[0])

    google.maps.event.addListener(autocomplete, "place_changed", function () {
      $("[id^=address-autocompleter-]").val("") // resets the previous values

      var place = this.getPlace()

      for (var i = 0; i < place.address_components.length; i++) {
        var component = place.address_components[i]

        for (var j = 0; j < component.types.length; j++) {
          if (component.types[j] == "street_number") {
            $("#address-autocompleter-street_number").val(component.long_name)
          } else if (component.types[j] == "route") {
            $("#address-autocompleter-route").val(component.long_name).change()
          } else if (component.types[j] == "postal_code") {
            $("#address-autocompleter-postal_code").val(component.long_name).change()
          } else if (component.types[j] == "locality" || component.types[j] == "postal_town") {
            $("#address-autocompleter-city").val(component.long_name).change()
          } else if (component.types[j] == "country") {
            $("#address-autocompleter-country_code").val(component.short_name).change()
          }
        }
      }
    })
  }

  // Registers the listeners that will be triggered when the hidden
  // result holders change. The value of the hidden result holder is
  // assigned to the matching targets.
  autofillAddress() {
    $("#address-autocompleter-route").change({ context: this }, function (e) {
      var values = [$("#address-autocompleter-street_number").val(), $("#address-autocompleter-route").val()]
      e.data.context.addressTarget.value = values
        .filter(function (val) {
          return val
        })
        .join(" ")
    })

    $("#address-autocompleter-postal_code").change({ context: this }, function (e) {
      e.data.context.postalcodeTarget.value = $(e.target).val()
    })

    $("#address-autocompleter-city").change({ context: this }, function (e) {
      e.data.context.cityTarget.value = $(e.target).val()
    })

    $("#address-autocompleter-country_code").change({ context: this }, function (e) {
      e.data.context.countrycodeTarget.value = $(e.target).val()
      e.data.context.countrycodeTarget.dispatchEvent(new Event("change"))
    })
  }

  // Creates the hidden inputs that will be filled by the autocompleter
  // once an address is selected by the user
  createResultHolders(controller) {
    ;["street_number", "route", "postal_code", "city", "country_code"].forEach(function (name) {
      $("<input>")
        .attr("type", "hidden")
        .attr("id", "address-autocompleter-" + name)
        .appendTo(controller)
    })
  }
}
